export function createRandomString(num) {
    return [...Array(num)].map(() => Math.random().toString(36)[2]).join('');
}
